<template>
  <div class="mergetables">
    <div class="filter">
      <el-form ref="form" :model="filterForm" label-width="80px">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="订单号">
              <el-input v-model="filterForm.orderNumber" clearable placeholder="订单号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单时间">
              <el-date-picker
                  v-model="filterForm.date"
                  clearable
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期" type="daterange"
                  value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button style="" type="primary" @click="handleSearch">搜索</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table_block">
      <table-order :orderList="orderList" @getData="getData"></table-order>
    </div>
    <div class="display_flex" style="margin:40px 0 20px 0">
      <el-pagination
          :total="total"
          :page-size="pageSize"
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          @current-change="currentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import tableOrder from "@/views/mineCenter/MineOrderForGoods/componets/tableOrder";
import { post } from '@/utils/request'

export default {
  name: "mergeTables",
  props: {
    // 订单状态
    orderStatus: {
      type: String,
      default: ''
    }
  },
  components: {
    tableOrder
  },
  data () {
    return {
      filterForm: {},
      total: 0,
      pageSize: 10,
      currentPage: 1,
      orderList: []
    }
  },
  methods: {
    currentChange (page) {
      this.currentPage = page
      this.getData()
    },

    handleSearch () {
      this.currentPage = 1
      this.getData()
    },

    getData () {
      let params = {
        status: this.orderStatus === 'all' ? '' : this.orderStatus, // 订单状态
        memberId: localStorage.getItem('memberId'),
        orderNumber: this.filterForm.orderNumber,
        startTime: this.filterForm.date && this.filterForm.date[0],
        endTime: this.filterForm.date && this.filterForm.date[1]
      }
      post('/gateway/venue-order/page', {
        page: {
          size: this.pageSize,
          current: this.currentPage
        },
        data: params
      }).then(res => {
        if (res.code === 0) {
          this.orderList = res.data.records
          this.total = res.data.total
        }
      })
    }
  },
  watch: {
    orderStatus: {
      handler () {
        this.filterForm = {}
        this.currentPage = 1
        this.getData()
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.mergetables {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .table_block {
    flex: 1;
    width: 100%;
  }

  .filter {
    height: 80px;
    width: 80%;
    display: flex;
    align-items: center;

    .label {
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
    }
  }
}

::v-deep .el-form-item__label {
  font-size: 14px;
}

::v-deep .el-input__inner {
  width: 100%;
}
</style>
